<template>

  <layout-with-sidebar>

    <HeaderComponent/>


    <div class="bg" style="height:100%;">
      <div class="container">
        <div class="pricing-header px-3 py-3 pt-md-3 pb-md-3 mx-auto text-center">
          <h1 class="h3 mb-3 font-weight-normal ">Scegli una Licenza</h1>
          <p class="lead h5 mb-3">Acquista la licenza a te piu idonea.</p>
        </div>
      </div>
      <div class="container">
        <div class="card-deck mb-3 text-center">

          <div class="card mb-4 box-shadow" v-if="isLoaded">
            <div class="card-header">
              <h4 class="my-0 font-weight-normal text-dark">Licenza Gratuita</h4>
            </div>
            <div class="card-body">
              <h1 class="card-title pricing-card-title text-dark">
                0€
                <small class="text-muted">/ mese</small>
              </h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>1 mese di utilizzo</li>
                <li class="mt-2 mb-0 text-muted">Sono presenti alcune limitazioni</li>
                <li class=" text-muted">Es: il pdf generato stampa cambiali contiene la scritta acquista
                  licenza
                </li>
              </ul>
            </div>
          </div>

          <div class="card mb-4 box-shadow" v-for="(plan, index) in plans"
          >
            <div class="card-header">
              <h4 class="my-0 font-weight-normal text-dark">{{ plan.name }}</h4>
            </div>
            <div class="card-body">
              <h1 class="card-title pricing-card-title text-dark">

                {{ (plan.total_amount / plan.months).toFixed(2) }}€
                <small class="text-muted">/ mese</small>
              </h1>
              <ul class="list-unstyled mt-3 mb-4">

                <li class=" text-muted">{{ plan.description }}</li>
              </ul>
              <!--
               @click="setProduct(plan)"
       -->
              <button type="button" class="btn btn-lg btn-block btn-success"
                      :disabled="userPlan && userPlan.plan.id === plan.id"
              @click="isBuyMode=!isBuyMode"
              >
                <span
                    v-if="userPlan && userPlan.plan.id === plan.id">Attivo fino al {{ userPlan.date_end | moment('D-M-Y') }}</span>
                <span v-if="!userPlan || (userPlan && userPlan.plan.id !== plan.id)">Acquista</span>
              </button>
            </div>
          </div>

          <div class="card mb-4 box-shadow" v-if="isLoaded">
            <div class="card-header">
              <h4 class="my-0 font-weight-normal text-dark">Licenza 50 cambiali</h4>
            </div>
            <div class="card-body">
              <h1 class="card-title pricing-card-title text-dark">
                3€
              </h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li class="text-muted">3€ per massimo 50 cambiali<br><br>
                </li>
              </ul>
              <button type="button"      @click="isBuyMode=!isBuyMode" class="btn btn-lg btn-block btn-success"
              >
                <span>Acquista</span>
              </button>
            </div>
          </div>

          <div class="col-12">
            <div class="alert alert-info" style="background:#399 !important;color:white" v-if="isLoaded">
              <h3 >Per acquistare chiamaci al +39 327 658 9383</h3>
            </div>
          </div>
          <div class="col-12">
            <div class="alert alert-info" style="font-size:18px;background:#399 !important;color:white" v-if="isLoaded && isBuyMode">
              Attualmente nn è possibile acquistare la licenza direttamente dall'app cliccando sul bottone "Acquista" della rispettiva licenza.
              <br>
              Se intendi acquistare una licenza chiamaci senza impegno al seguente numero +39 3276589383.
              Ti risponderemo subito, e se siamo occupati vi ricontatteremo dopo qualche minuto.
              <br>
              Tel: +39 327 658 9383
            </div>
          </div>

        </div>
        <!-- {{plan.total_amount}}€ -->
        <!-- {{Math.round10(plan.total_amount, 0)}} -->
        <!-- <li>30 giorni di utilizzo.</li> -->
        <!-- <li>Fatturari annualmente</li>
        <li>ovvero {{plan.total_amount}}€ + IVA l'anno</li> -->
        <div class="row">
          <div class="col-12 text-center" style="padding:20px;">
            <div v-if="isTrialUser" style="width:80%;margin-top:30px;float:left;background:white;">
              <card v-show="currentProduct" class='stripe-card'
                    :class='{ complete }'
                    stripe='pk_test_XuCCTRjMY42fqMnbC2KUJgx2'
                    :options='stripeOptions'
                    @change='complete = $event.complete'
              />
              <button v-show="currentProduct" class='pay-with-stripe btn btn-success' @click='pay'
                      :disabled='!complete'>
                Paga con Carta di Debito / Credito
              </button>

              <img v-show="currentProduct" src="/images/logo-stripe.png" style="float: right;
width: 157px;
margin-top: 14px;">
            </div>
          </div>

        </div>


      </div>
    </div>

  </layout-with-sidebar>


</template>


<script>
// @ is an alias to /src
import axios from 'axios'
import {Card, createToken} from 'vue-stripe-elements-plus'
import LayoutWithSidebar from '@/components/layouts/LayoutWithSidebar'

import HeaderComponent from '../../components/HeaderComponent.vue'

export default {
  name: 'ProfilePlan',
  components: {
    Card,
    LayoutWithSidebar,
    HeaderComponent
  },
  data: function () {
    return {
      isBuyMode: false,
      token: null,
      plans: [],
      isLoaded: false,
      userPlan: {
        plan: {}
      },
      complete: false,
      currentProduct: false,
      stripeOptions: {
        base: {
          color: '#303238',
          fontSize: '16px',
          color: '#32325d',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#ccc',
          },
        },
        invalid: {
          color: '#e5424d',
          ':focus': {
            color: '#303238',
          },
        }
      }
    }
  },
  mounted: function () {
    this.getPlans()
    this.getUserPlan()
  },
  computed: {},
  methods: {
    setProduct: function (plan) {
      this.currentProduct = plan
    },
    pay: function () {
      var $vm = this
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      createToken().then(function (data) {
        $vm.buyPlan(data.token)
      })
    },
    getPlans: function () {
      var $vm = this
      axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/plan')
          .then(function (response) {
            $vm.plans = response.data
            $vm.isLoaded = true
          })
    },
    getUserPlan: function () {
      var $vm = this
      axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/user/' + $vm.loggedUser.id + '/plan')
          .then(function (response) {
            $vm.userPlan = response.data
          })
    },
    buyPlan: function (token) {
      var $vm = this
      $vm.token = token.id
      var params = {
        user: {
          id: $vm.loggedUser.id
        },
        plan: {
          id: $vm.currentProduct.id
        }
      }

      axios.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/subscription/create-payment', params)
          .then(function (response) {

            var payParams = {
              token: $vm.token,
              order_id: response.data.id,
              user: {
                id: $vm.loggedUser.id
              },
              plan: {
                id: $vm.currentProduct.id
              }
            }

            axios.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/subscription/pay', payParams)
                .then(function (response) {
                  alert('Pagamento effettuato!')

                  axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/user/me')
                      .then(function (response) {
                        $vm.$cookies.set('user', response.data)

                        //ricarico la pagina per far aggiornare il valore del cookie e ricaricare tutti i componenti per leggere
                        //il valore aggiornato dai cookies is_completed
                        location.reload()
                      }).catch(error => {
                  });

                }).catch(function (error) {
              alert(error.response.data.message)
            })
          })
    }
  }
}
</script>


<style scoped>
.stripe-card {
  padding: 20px;
}

.__PrivateStripeElement iframe .ElementsApp, iframe .ElementsApp .InputElement {
  font-size: 20px !important;
}

/**
* The CSS shown here will not be introduced in the Quickstart guide, but shows
* how you can use CSS to style your Element's container.
*/
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.pay-with-stripe {
  margin-top: 20px;
  margin-bottom: 20px;
}


.bg {
  background-color: #272F44;
  background-color: #222939;
}


.pricing-header {
  color: white;
}


.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}

.form-signin .form-control:focus {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

</style>
